import React from 'react';
import withLabelAndMeta from './withLabelandMeta';

const FieldText = ({
  field, // { name, value, onChange, onBlur }
  fieldDefinition,
}) => (
  <b id={fieldDefinition.key} {...field}>
    : {field.value}
  </b>
);

export default withLabelAndMeta(FieldText, true);
